import React from 'react';

import { Layer, Source } from 'react-map-gl';

import { selectedPathGraph } from '../../mapStyles';

const graphSelectedStyle  = selectedPathGraph();

export const FeaturePathGraph = ({feature}) => {
  return (
    <Source id={'selected_graph'} type='geojson' data={feature}>
      <Layer id={'selected_graph'} {...graphSelectedStyle} />
    </Source>
  );
};